import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme.busbud;

  return {
    container: {
      display: "block",
      paddingRight: spacing(1),
      textAlign: "right"
    },
    major: {
      paddingTop: spacing(0.25),
      paddingBottom: spacing(0.25)
    },
    label: {
      display: "block"
    }
  };
});
